import script from "./ETooltip.vue?vue&type=script&lang=ts&setup=true"
export * from "./ETooltip.vue?vue&type=script&lang=ts&setup=true"

import "./ETooltip.vue?vue&type=style&index=0&id=63dd27b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63dd27b3"]])

export default __exports__